import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { closePopup } from '../../actions/uiActions'
import { createDatabase, editDatabase, testDatabase } from '../../actions/userActions'
import CloseIcon from '@mui/icons-material/Close';

class AddEditDatabase extends React.Component {
    state = {
        customerID: "",
        servertype: 0,
        server: "",
        dbname: "",
        username: "",
        password: "",
        teamIDs: [],
        testingDatabase: false,
        databaseCheckRun: false,
        databaseCheckPassed: false
    }

    componentDidMount() {
        if (this.props.popupInfo != null) {
            let database = this.props.databaseList.find(x => x.id === this.props.popupInfo)
            let allTeamIds = []
            if (database.databaseTeams && database.databaseTeams.length > 0) {
                for (let x = 0; x < database.databaseTeams.length; x++) {
                    allTeamIds.push(database.databaseTeams[x]["teamID"])
                }
            }

            this.setState({
                customerID: database.customerID,
                servertype: database.serverType,
                server: database.server,
                dbname: database.dBname,
                username: database.userName,
                password: database.password,
                teamIDs: allTeamIds
            })
        }
    }

    changeServerType = (event) => {
        this.setState({ servertype: event.target.value, databaseCheckRun: false, databaseCheckPassed: false })
    }

    changeServer = (event) => {
        this.setState({ server: event.target.value, databaseCheckRun: false, databaseCheckPassed: false })
    }

    changeDBname = (event) => {
        this.setState({ dbname: event.target.value, databaseCheckRun: false, databaseCheckPassed: false })
    }

    changeUsername = (event) => {
        this.setState({ username: event.target.value, databaseCheckRun: false, databaseCheckPassed: false })
    }

    changePassword = (event) => {
        this.setState({ password: event.target.value, databaseCheckRun: false, databaseCheckPassed: false })
    }


    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    handleSubmit = (event) => {
        event.preventDefault()

        let selectedCustomerId = -1
        if (this.props.role === "IEAdmin") {
            selectedCustomerId = this.state.customerID
        } else {
            selectedCustomerId = this.props.currentUser.customerID
        }

        // db ID
        if (this.props.popupInfo == null) {
            this.props.createDatabase(selectedCustomerId, this.state.servertype, this.state.server, this.state.dbname, this.state.username, this.state.password, this.state.teamIDs);
        } else {
            this.props.editDatabase(this.props.popupInfo, this.state.customerID, this.state.servertype, this.state.server, this.state.dbname, this.state.username, this.state.password, this.state.teamIDs);
        }
    }

    handleTestDatabase = (event) => {
        event.preventDefault()
        this.setState({ testingDatabase: true })

        this.props.testDatabase(
            this.props.popupInfo,
            this.state.customerID,
            this.state.servertype,
            this.state.server,
            this.state.dbname,
            this.state.username,
            this.state.password
        ).then((resp) => {
            if (resp.status === 200) {
                this.setState({ testingDatabase: false, databaseCheckRun: true, databaseCheckPassed: true })
            } else {
                this.setState({ testingDatabase: false, databaseCheckRun: true, databaseCheckPassed: false })
            }
        }).catch((ex) => {
            this.setState({ testingDatabase: false, databaseCheckRun: true, databaseCheckPassed: false })
        })
    }

    handleCustomerID = (event) => {
        event.preventDefault()
        this.setState({ customerID: event.target.value })
    }


    populateCustomers = () => {
        if (this.props.role === "IEAdmin") {
            return (
                <>
                    <Select
                        className="myInput"
                        onChange={this.handleCustomerID}
                        value={this.state.customerID}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                        disabled={(this.props.popupInfo != null)}
                    >
                        <MenuItem value="" disabled hidden>
                            Select Customer
                        </MenuItem>
                        {this.props.customerList.map((x) => <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)}
                    </Select>
                </>
            )
        }

        return null
    }

    populateTeams = () => {
        let selectedCustomerId = -1
        if (this.props.role === "IEAdmin") {
            selectedCustomerId = this.state.customerID
        } else {
            selectedCustomerId = this.props.currentUser.customerID
        }

        if (selectedCustomerId !== null && selectedCustomerId > -1 && (this.props.role === "IEAdmin" || this.props.role === "ClientAdmin")) {
            let teams = this.props.teamList.filter(x => x.customer.id === parseInt(selectedCustomerId)).sort((a, b) => parseFloat(a.id) - parseFloat(b.id));
            if (teams.length > 0) {
                return (<div className="adminSelectbox">
                    <div className="checkOut">
                        <label className="checkHead">Teams:</label>
                        <ul>
                            {teams.map(x => (
                                <li key={`teams-checkbox-${x.id}`}>
                                    <FormControlLabel
                                        control={(
                                            <Checkbox
                                                key={x.id}
                                                onChange={this.handleTeamsCheckBoxes}
                                                name="checkedA"
                                                value={x.id}
                                                checked={this.state.teamIDs.includes(x.id)} />
                                        )}
                                        label={x.name} />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>)
            }
        }
        return null
    }

    handleTeamsCheckBoxes = (event) => {
        let ind = this.state.teamIDs.findIndex(x => x === parseInt(event.target.value))
        let arr = this.state.teamIDs
        if (ind !== -1) {
            arr.splice(ind, 1)
        } else {
            arr.push(parseInt(event.target.value))
        }
        this.setState({ teamIDs: arr })
    }

    returnTestButtonClassName = () => {
        if (this.state.databaseCheckRun) {
            if (this.state.databaseCheckPassed) {
                return "ml-5 btn btn-success"
            } else {
                return "ml-5 btn btn-danger"
            }
        }
        return "ml-5 btn"
    }

    returnTestDatabaseButtonText = () => {
        if (this.state.databaseCheckRun) {
            if (this.state.databaseCheckPassed) {
                return "Connection Successful"
            } else {
                return "Connection Test Failed"
            }
        }
        return "Test Database"
    }

    render() {
        return (
            <Dialog
                open={true}
                onClose={this.handleClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <CloseIcon onClick={this.handleClick} className="closePoup" />
                <DialogTitle id="alert-dialog-title" className="changepassdialog">
                    {(this.props.popupInfo == null) ? "Add New Database Record" : "Edit Database Record"}
                </DialogTitle>
                <DialogContent>
                    <form className="form" onSubmit={this.handleSubmit} >
                        <div className="adminSelectbox">
                            <h5 className="mainLable">Customer:</h5>
                            <div className="myInputOut">
                                {this.populateCustomers()}
                            </div>
                        </div>
                        <h5 className="mainLable">Server Type:</h5>
                        <div className="myInputOut">
                            <Select
                                className="myInput"
                                onChange={this.changeServerType}
                                defaultValue={this.state.servertype}
                                inputProps={{ 'aria-label': 'Without label' }}
                            >
                                <MenuItem value="0">SQL Server</MenuItem>
                                <MenuItem value="1">SSAS Server</MenuItem>
                            </Select>

                        </div>
                        {this.populateTeams()}
                        <h5 className="mainLable">Server Name</h5>
                        <div className="myInputOut">
                            <input
                                type="text"
                                className="myInput"
                                onChange={this.changeServer}
                                defaultValue={this.state.server}
                                placeholder=""
                            />
                        </div>
                        <h5 className="mainLable">Database:</h5>
                        <div className="myInputOut">
                            <input
                                type="text"
                                className="myInput"
                                onChange={this.changeDBname}
                                defaultValue={this.state.dbname}
                                placeholder="" id="database_txt" required
                            />
                        </div>
                        <h5 className="mainLable">Read Only User Name:</h5>
                        <div className="myInputOut">
                            <input
                                type="text"
                                className="myInput"
                                onChange={this.changeUsername}
                                defaultValue={this.state.username}
                                placeholder="" id="username_txt" required
                            />
                        </div>
                        <h5 className="mainLable">Password:</h5>
                        <div className="myInputOut">
                            <input
                                type="password"
                                className="myInput"
                                onChange={this.changePassword}
                                defaultValue={this.state.password}
                                placeholder="" id="password_txt" required
                            />
                        </div>

                        <button className="btn" type="submit" value="Submit" id="submit_btn">Submit</button>
                        <button className={this.returnTestButtonClassName()} value="Test Database" id="test_btn" onClick={this.handleTestDatabase} disabled={this.state.testingDatabase}>{this.returnTestDatabaseButtonText()}</button>
                    </form>
                </DialogContent>
            </Dialog>
        )
    }
}


function mapStateToProps(state) {
    return {
        user: state.users,
        popupInfo: state.ui.popupInfo,
        databaseList: state.users.databaseList,
        customerList: state.users.customerList,
        teamList: state.users.teamList,
        currentUser: state.users.currentUser,
        role: state.users.role
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, createDatabase, editDatabase, testDatabase }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddEditDatabase)